import {
  useDispatch as useDispatchR,
  useSelector as useSelectorR,
} from 'react-redux';
import type { TypedUseSelectorHook } from 'react-redux';
import type { RootState, AppDispatch } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useDispatch: () => AppDispatch = useDispatchR;
export const useSelector: TypedUseSelectorHook<RootState> = useSelectorR;
